<template>
    <table
        :id="id"
        class="w-full border-collapse border border-gray-400"
        :class="class"
        @click.capture="changeTableId"
    ><!-- Capture, because this click event needs to be triggered before the click on the th -->
        <slot />
    </table>

    <Paging
        :pageSize="pageSize"
        :values="values"
        :filters="filters"
        @click.capture="changeTableId"
        v-if="(values.length > 0 || (typeof values.data !== 'undefined'))
            && id !== 'undefined'
            && !(state.side[id] === 'client' && state.allValues[id].length <= pageSize && state.currentPage[id] == 1)
            && !(state.side[id] === 'server' && values.total <= pageSize && state.currentPage[id] == 1)
            && !(typeof state.side[id] === 'undefined' && state.allValues[id].length <= pageSize && state.currentPage[id] == 1)
        "
    /><!-- Capture, because this click event needs to be triggered before the click on the pager buttons -->
</template>

<script>
import {ref, watch} from 'vue'

import Paging from '@/Components/Paging.vue';

import store from "../store";
import moment from "moment"

export default {
    components: {
        Paging
    },
    props: {
        values: {
            type: [Array, Object],
            default: [],
            // required: true
        },
        filters: {
            type: [Array, Object],//Only server side filters atm, to do client side
            default: [],
        },
        class: {
            type: String,
        },
        id: { //Unique id for the table
            type: String,
            // required: true,
            default: () => (Math.floor(Math.random() * 1000000) + 1).toString(),
        },
        pageSize: {
            type: Number,
            default: 50,
        },
    },
    setup (props) {
        let pageSize = props.pageSize;

        if (props.values.length > 0 || Object.keys(props.values).length > 0 || (typeof props.values.data !== 'undefined'))
        {
            //Set initial store values
            store.changeTableId({id: props.id});
            store.changeCol({column: '', id: props.id})
            store.changeDir({dir: 'asc', id: props.id})

            //Check if we need to do sort/paging on client or server side
            if (props.values.data) {
                //server side
                store.changeSide({id: props.id, side: 'server'})
                store.changeAllValues({values: props.values.data, id: props.id})
                pageSize = props.values.per_page;
            } else {
                //client side
                store.changeSide({id: props.id, side: 'client'})
                store.changeAllValues({values: props.values, id: props.id})
            }
        }

        //When we do a sort or change page, we need to know the table id
        function changeTableId() {
            store.changeTableId({id: props.id})
        }

        //When values change
        watch(() => props.values, (currentVals, oldVals) => {

            store.changeTableId({id: props.id});
            store.changeCurrentPage({id: props.id, currentPage: 1})
            store.changeCurrentFilters({id: props.id, filters: props.filters})

            if (currentVals.data) {
                //server side
                store.changeAllValues({values: currentVals.data, id: props.id})
            } else {
                //client side
                store.changeAllValues({values: currentVals, id: props.id})
            }
        })

        return {
            state: store.state,
            ...store,
            changeTableId,
            pageSize,
        }
    },
}
</script>

<style>
tr:hover td  {
    background: rgb(243, 244, 246);
}
</style>


